import type { FC } from 'react'
import { useState } from 'react'

import type { Application } from '@/types/Activity'
import { hasAdverseCredit } from '@/utils/adverseCredit'

import ResetButton from './ResetButton'
import ResetSidebar from './Sidebar'

interface Props {
  application: Application
  customerId: string
  applicationId: string
  subjectId: string
  disabled?: boolean
}

const Reset: FC<Props> = ({
  application,
  customerId,
  applicationId,
  subjectId,
  disabled,
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false)
  return (
    <>
      {isSidebarOpen && (
        <ResetSidebar
          customerId={customerId}
          applicationId={applicationId}
          subjectId={subjectId}
          hasAdverseCredit={hasAdverseCredit(application)}
          onClose={() => setIsSidebarOpen(false)}
        />
      )}
      <ResetButton disabled={disabled} onClick={() => setIsSidebarOpen(true)} />
    </>
  )
}

export default Reset
